import { useUser } from '@clerk/nextjs';
import { useAnalytics } from '@web-app/context/AnalyticsContext';
import React from 'react';

import { CallQualitySurveyModalContent } from './CallQualitySurveyModalContent';
import type { CallQualitySurveyModalProps } from './types';

// Main component that uses hooks and passes them to the content component
export const CallQualitySurveyModal: React.FC<
  Omit<CallQualitySurveyModalProps, 'user' | 'trackEvent'>
> = (props) => {
  const { user } = useUser();
  const { trackEvent } = useAnalytics();

  // Map Clerk user to component's expected format
  const mappedUser = user
    ? {
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
      }
    : null;

  return (
    <CallQualitySurveyModalContent
      {...props}
      user={mappedUser}
      trackEvent={trackEvent}
    />
  );
};
